import React, {Component} from 'react'

import SingleInput from './SingleInput'

class Form extends Component {

  render () {

    return (
      <form className="Form">
          <SingleInput {...this.props}/>
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/js/components/Forms/Form.jsx